import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const ltrCache = createCache({
    key: 'mui',
});

const RhfRtlProvider = ({ children }) => {
    const isDev = import.meta.env.MODE === 'development';

    if (!isDev) return null;

    return (
        <div dir="ltr">
            <CacheProvider value={ltrCache}>{children}</CacheProvider>
        </div>
    );
};

export default RhfRtlProvider;
